import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { TableFieldService, ZoningCodeService } from 'src/app/core/services';
import { IAttributesIdentifiers } from 'src/app/interfaces/attributes-identifiers.interface';
import { IFieldSettings } from 'src/app/interfaces/field-settings.interface';
import { ZoningCodeAttribute } from 'src/app/models';
import { getMeasurementUnitsTitle, TableType } from '../../../../shared/enums';
import { CalibrationSetCollectionName } from '../../../../shared/enums/calibration-set-type';
import { IBaseTable } from 'src/app/interfaces/calibration-set-table.interface';

@Component({
    standalone: false,
    selector: 'ziq-header-field',
    templateUrl: './header-field.component.html',
    styleUrls: ['./header-field.component.scss']

})
export class HeaderFieldComponent implements OnInit {
    @HostBinding('class')
    readonly hostClass = 'ziq-header-field';

    @Input()
    fieldSettings: IFieldSettings;

    @Input()
    tableType?: TableType;

    @Input()
    currentTab: string;

    @Input()
    table: IBaseTable;

    @Input()
    hideAttributeButtons: boolean = false;

    @Input()
    readOnly: boolean = false;

    identifier: IAttributesIdentifiers;

    constructor(protected zoningCodeService: ZoningCodeService, protected tableFieldService: TableFieldService) {}

    ngOnInit() {
        this.identifier = {
            tableField: this.fieldSettings,
            tableType: this.tableType
        };
    }

    get isZones() {
        return this.currentTab === CalibrationSetCollectionName.CALIBRATION_ZONE_COMBINATION;
    }

    getMeasurementUnitsTitle(unitsNumber: number) {
        return getMeasurementUnitsTitle(unitsNumber, this.zoningCodeService.unitSystem);
    }

    getAttributesFlags() {
        const identifier = ZoningCodeAttribute.getIdentifier({
            TableType: this.tableType,
            TableFieldId: this.tableFieldService.tableFields.get(this.fieldSettings.name).Id,
            ZoningCodeId: this.zoningCodeService.selectedZoningCode.Id
        });
        return this.zoningCodeService.selectedZoningCode.attributes.ZoningCodeAttributesStatistics.get(identifier) || {};
    }
}
